<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hotelCheapestRateObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>
            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">Cost Compared to Hotel's Lowest Rate</p>
                    <p>Trigger for any room rate when the total cost exceeds the hotel's lowest rate by <span
                            class="rule-config-variable" @click="isEdit = !isEdit">
                            <span v-if="hotelCheapestRateObj.value.unit == 'dollars'">$</span>
                            {{ hotelCheapestRateObj.value.cost }}
                            <span v-if="hotelCheapestRateObj.value.unit == 'percent'">%</span>
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span></p>
                </div>
                <div class="allbtns">

                    <b-switch :rounded="true" :value="hotelCheapestRateObj.isActive"
                        v-model="hotelCheapestRateObj.isActive" @input="hotelCheapestRate" :left-label="true">{{
                            hotelCheapestRateObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>

            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <HotelCheapestRate :rateOptions="propsData" @hotelCheapestRate="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
    </div>
</template>
<script>
import HotelCheapestRate from "../CommonRules/HotelCheapestRate.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {HotelCheapestRate},
    data() {
        return {
            propsData: {
                amountVal: 5,
                amountType: 'percent'
            },
            hotelCheapestRateObj: this.value ? this.value
                : {
                    name: 'hotelCheapestRate',
                    isActive: false,
                    message: 'Trigger when room rate is greater the cheapest room rate by a certain amount.',
                    type: 'hotel',
                    value: {
                        cost: 5,
                        unit: 'percent'
                    }
                },
            isEdit: false,
            emitedValue: null

        }

    },
    computed: {
        buildMessage() {
            let _cost = this.hotelCheapestRateObj.value.cost
            let _unit = this.hotelCheapestRateObj.value.unit
            var string =
                "Trigger when room rate is more than " + _cost + ' ' + _unit + " compared with the benchmarked cheapest rate.";
            return string

        },
    },
    methods: {
        hotelCheapestRate(){
            this.$emit("hotelCheapestRate", this.hotelCheapestRateObj);
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue) {
                this.hotelCheapestRateObj.value = this.emitedValue;
            }
        }
    },
    mounted() {
        this.$emit("hotelCheapestRate", this.hotelCheapestRateObj);
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const hotelProps = this.value;
                    this.hotelCheapestRateObj = hotelProps
                    this.propsData.amountVal = hotelProps.value.cost;
                    this.propsData.amountType = hotelProps.value.unit;
                }
                this.hotelCheapestRateObj.message = this.buildMessage;
                this.hotelCheapestRateObj.type = "hotel";
                this.$emit("hotelCheapestRate", this.hotelCheapestRateObj);
            },
            deep: true,
        },
    }
}
</script>